import { Phone, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const CTABand = ({ title = "Une serrure bloquée ? Une porte claquée ?", subtitle = "Notre artisan intervient en moins de 30 minutes dans votre commune." }) => {
    return (
        <section className="bg-[#0A0A0A] text-white" data-testid="cta-band">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-[#E63946] mb-4">
                            ◉ Disponible maintenant — 24/7
                        </div>
                        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight">
                            {title}
                        </h2>
                        <p className="mt-5 text-zinc-400 text-base sm:text-lg max-w-xl leading-relaxed">{subtitle}</p>
                    </div>

                    <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-3">
                        <a
                            href="tel:+33649501843"
                            data-testid="ctaband-call-btn"
                            className="inline-flex items-center justify-between gap-4 bg-[#E63946] hover:bg-[#D62828] transition-colors px-6 py-5 text-white"
                        >
                            <span className="flex items-center gap-3">
                                <Phone className="h-5 w-5" strokeWidth={2.4} />
                                <span>
                                    <span className="block text-[10px] uppercase tracking-[0.2em] text-white/80 font-semibold">Appel d'urgence</span>
                                    <span className="font-display font-bold text-xl tracking-tight">06 49 50 18 43</span>
                                </span>
                            </span>
                            <ArrowUpRight className="h-5 w-5" />
                        </a>
                        <Link
                            to="/contact"
                            data-testid="ctaband-quote-btn"
                            className="inline-flex items-center justify-between gap-4 bg-white text-black hover:bg-zinc-200 transition-colors px-6 py-5"
                        >
                            <span>
                                <span className="block text-[10px] uppercase tracking-[0.2em] text-zinc-600 font-semibold">Demande en ligne</span>
                                <span className="font-display font-bold text-base tracking-tight">Devis gratuit</span>
                            </span>
                            <ArrowUpRight className="h-5 w-5" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTABand;
